export function getView(status) {
  return status !== null && status !== 'active' ? 'IsNotVerified' : 'OtherError'
}
